module.exports = __webpack_public_path__ + "static/img/logohome.e674bdbd.png";